import { BookingStrategyContext } from "./bookingStrategies";

export const buildUsers = (ctx: BookingStrategyContext) =>
  ctx.transformBookingUsers(
    ctx.inputs.usersBookedFor,
    ctx.sub,
    ctx.inputs,
    ctx.timezoneMobileWorking,
    true
  );
